import React from 'react'

export default function Spacer({className}) {
    return (
        <div className={'h90 '+(className ? className : '')}/>
    )
}
